"use strict";
exports.__esModule = true;
var Donut_1 = require("./Donut");
exports.Donut = Donut_1["default"];
